import { useUserStore } from "@/stores/user";
import type { MiddlewareContext } from "@/types";

export const blockLearners = ({ next, router }: MiddlewareContext) => {
  const store = useUserStore();

  if (store.isOnlyLearner) {
    router.push({ name: "NotFound" });
    return;
  }

  return next();
};
